export default __webpack_public_path__ + "static/media/Vika.34a4179d.svg";